import { Box, Typography, Paper, Grid } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  imprestApplications,
  leaveApplications,
  leaveApplicationsByUser,
  staffClaimApplications,
  staffClaimApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import {
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
  staffClaimApplicationsColumns,
  staffClaimLinesColumns,
} from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import LeaveApplicationForm from "./form";
import StaffClaimApplicationForm from "./form";
import StaffClaimApplicationLineForm from "./linesForm";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

function StaffClaimsLinesTable() {
  const data = parseInt(localStorage.getItem("claimApplicationId"));
  const base_url = HRService.uri;
    const [totalAmount, setTotalAmount] = useState("KES 0.00");
    const [loading, setLoading] = useState(true);
    const [staffClaimApplicationsData, setStaffClaimApplications] = useState([]);
  
    
      async function fetchStaffClaimApplications() {
        const params = { applicationId: data };
    
        try {
          const result = await fetchJson({
            objectName: "staffClaimLinesByApplication",
            inputObjectName: "staffClaimLines",
            params,
            baseUrl: base_url,
          });
    
          if (result) {
            const parsedData = JSON.parse(result.results);
            setStaffClaimApplications(parsedData);
    
            const total = parsedData.reduce((sum, item) => sum + (item.Amount || 0), 0);
            const formattedTotal = total.toLocaleString("en-KE", {
              style: "currency",
              currency: "KES",
            });
            setTotalAmount(formattedTotal);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
    
      useEffect(() => {
        fetchStaffClaimApplications();
      }, []);

  const actions = {
    entity: " Staff Claim Approvals",

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

    AssignTask: {
      key: "ASSIGN_TASK",
      button_name: "Assign Task",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    removeSurrenderLine: {
      key: "REMOVE_RELIEVER",
      button_name: "Remove Line",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
    },
    dataObjectForMutation: {
      inputObjectName: "addRemoveStaffClaimLines",
      inputSubObjectName: "lines",
      inputFields: ["applicationId", "userId", "comments"],
      actionName: "Leave Application ",
    },

    dataObject: {
      parameters: {
        applicationId: data,
      },
      objectName: "staffClaimLinesByApplication",
      inputObjectName: "staffClaimLines",
      //returnFields: ["id", "applicationId", "description", "amount"],
    },
    showStatus: true,
  };
  
  return (
    <Box m={1}>
        <Paper
              elevation={2}
              sx={{
                mb: 2,
                px: 2,
                py: 1,
                backgroundColor: "#f0f8ff",
              }}
            >
              <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                <Grid item xs={6} sm={3}>
                  <Typography variant="subtitle2" color="textSecondary">Total Claim:</Typography>
                  <Typography variant="h6">Ksh {parseInt(data.TotalAmount) || 0.00}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Typography variant="subtitle2" color="textSecondary">Total Claim Lines:</Typography>
                  <Typography variant="h6">{totalAmount}</Typography>
                </Grid>
              </Grid>
            </Paper>
      
        <DynamicTableForJson
          title="Staff Claims Lines"
          subtitle="View your Staff ClaimLines, add or remove"
          columns={staffClaimLinesColumns}
          FormComponent={StaffClaimApplicationLineForm}
          // query={staffClaimApplicationsByUser}
          actions={actions}
          base_url={base_url}
        />
    </Box>
  );
}

export default StaffClaimsLinesTable;
